exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-obituary-details] main{grid-area:header-start/header-start/main-end/main-end}", ""]);

// exports
